
import {
  Component, Vue, Prop, ProvideReactive,
} from 'nuxt-property-decorator'

@Component({
  name: 'TabAccordion',
  components: {
    BaseAccordion: () => import('../base/accordion/BaseAccordion.vue'),
    BaseTab: () => import('../base/tab/BaseTab.vue'),
  },
})
export default class TabAccordion extends Vue {
  @Prop({ default: 'tabs' }) design! : 'accordion' | 'tabs'

  @ProvideReactive('accordion') isAccordion : boolean = this.design === 'accordion'

  private switchedToAccordionAtWidth : number = 0

  mounted () : void {
    // We only allow changing from 'tabs' to 'accordion' not the other way around
    if (this.design === 'accordion') return

    this.$nextTick(() => {
      this.checkComponentTypeState()
      window.addEventListener('resize', this.checkComponentTypeState)
    })
  }

  private setActiveIndex (index : number) : void {
    (this.$refs.child as any)?.setActiveIndex?.(index)
  }

  /**
   * Checks if an element is overflowing and switches the component type accordingly
   */
  private checkComponentTypeState () : void {
    if (this.isAccordion && (window.innerWidth > this.switchedToAccordionAtWidth)) {
      this.isAccordion = false

      // recheck if the tabs actually fit as soon as they are rendered
      this.$nextTick(this.checkComponentTypeState)
      return
    }

    // this following part only works if the flex container doesn't wrap
    const lastChild = this.$el?.querySelector('.tabs ul li:last-child') as HTMLElement
    if (!lastChild) return

    const { parentElement } = lastChild
    if (parentElement
      // +1 to ignore decimals and therefore improve the behavior (less false positives)
      && lastChild.getBoundingClientRect().right > parentElement.getBoundingClientRect().right + 1
    ) {
      if (!this.isAccordion) this.isAccordion = true
      if (this.switchedToAccordionAtWidth === 0) this.switchedToAccordionAtWidth = window.innerWidth
    }
  }
}
